import { apiEditor } from 'services/api/api';
import { EditorApiEndpoints } from 'utils/endpoints/endpoints';
import { appendQueryParams } from 'utils/requestUtils';

interface SelectOption {
  valor: string;
  descricao: string;
}

export const getValoresCampoSelect = async (
  registroCodigo: string,
  campoId: number,
  processamentoSpedId: string,
): Promise<SelectOption[]> => {
  const queryParams = {
    campoID: campoId,
  };

  const url = appendQueryParams(
    `${EditorApiEndpoints.GetCamposPorRegistro}${registroCodigo}/campos/select-valores`,
    queryParams,
  );
  const response = await apiEditor.get<SelectOption[]>(url, {
    headers: {
      'Processamento-Sped-ID': processamentoSpedId.toString(),
    },
  });

  return response.data;
};
